<template>
  <section class="original-analysis-board" aria-label="원본 분석">
    <div v-if="loading" role="status" class="original-analysis-status">분석 목록을 확인하고 있습니다.</div>
    <div v-else-if="error" role="alert" class="original-analysis-status"><p>분석 목록을 확인하지 못했습니다.</p><button type="button" @click="loadMenus">다시 확인</button></div>
    <div v-else-if="!charts.length" class="original-analysis-status">현재 제공되는 분석이 없습니다.</div>
    <persona-charts v-if="ready" :charts="charts" :context-key="contextKey" :active="active && routeActive" />
  </section>
</template>
<script>
import { api } from '../../mixins/api';
import { flattenMenus } from '../catalog';
import PersonaCharts from '../persona/PersonaCharts.vue';
import { originalCharts } from './original-analyses';

export default {
  name:'OriginalAnalysisBoard',
  components:{PersonaCharts},
  props:{mode:{type:String,default:'region'},groupIds:{type:Array,default:null},active:{type:Boolean,default:true}},
  data:()=>({items:[],loading:true,error:false,ready:false,routeActive:true}),
  computed:{
    charts(){
      // Only currently available original menu entries can reach the ticket gate.
      return originalCharts(this.mode,this.groupIds).map(reference=>this.items.find(item=>item.url===reference.url && item.category===reference.category)).filter(item=>item && !item.unavailable);
    },
    contextKey(){return this.mode+':'+(this.groupIds===null?'all':this.groupIds.join(','));}
  },
  created(){this.loadMenus();},
  activated(){this.routeActive=true;},
  deactivated(){this.routeActive=false;},
  methods:{
    async loadMenus(){
      this.loading=true;this.error=false;
      try{
        const [realestate,economy]=await Promise.all([api.methods.getMenuApi('realestate'),api.methods.getMenuApi('economy')]);
        if(!realestate || !economy)throw new Error('unavailable');
        this.items=flattenMenus({realestate,economy});this.ready=true;
      }catch(_){this.error=true;}
      finally{this.loading=false;}
    }
  }
};
</script>
<style scoped>
.original-analysis-board{min-width:0;background:#fff;border:1px solid #dce1e7;border-radius:6px;padding:20px}
.original-analysis-status{padding:20px 0;color:#526174;font-size:14px}
@media(max-width:700px){.original-analysis-board{padding:12px}}
</style>
